<template>
  <div class="min-h-full flex items-center justify-center mt-12">
    <div class="container-padded max-w-lg w-full shadow-md sm:p-12">
      <h2 class="text-center mb-4">
        <svg-vue icon="salesium-logo" class="w-8 inline-block mr-3" />
        Salesium
      </h2>
      <p class="text-center mb-5">Sign in to your account</p>

      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="onSubmit" class="space-y-6">
          <div>
            <ValidationProvider rules="required" v-slot="{ classes, errors }">
              <div class="control is-required" :class="classes">
                <label for="username">Username or Email</label>
                <input
                  id="username-address"
                  name="username"
                  autocomplete="username"
                  class="input-field block w-full"
                  required
                  v-model="username"
                  @click="clearValidationErrors"
                />
                <span class="text-red-500 text-hint">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div>
            <ValidationProvider rules="required" v-slot="{ classes, errors }">
              <div class="control is-required" :class="classes">
                  <div class="flex">
                      <label for="password">Password</label>
                      <form @submit.prevent="makeVisible"> 
                      <button class="flex ml-2 mt-1" @click.prevent="makeVisible">
                          <svg class=" flex h-5 w-5 text-red-500"  width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <circle cx="12" cy="12" r="2" />  <path d="M2 12l1.5 2a11 11 0 0 0 17 0l1.5 -2" />  <path d="M2 12l1.5 -2a11 11 0 0 1 17 0l1.5 2" /></svg>
                      </button>
                      </form>
                  </div>
                  <input
                      v-if="showPassword"
                      id="password"
                      name="password"
                      type="text"
                      autocomplete="current-password"
                      class="input-field block w-full"
                      required
                      v-model="password"
                      @click="clearValidationErrors"
                  />
                <input v-else
                  id="password"
                  name="password"
                  type="password"
                  autocomplete="current-password"
                  class="input-field block w-full"
                  required
                  v-model="password"
                  @click="clearValidationErrors"
                />
                <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                <span v-if="validationErrors">
                  <span class="text-red-500 text-hint" v-for="(error, i) in validationErrors" :key="i">{{ error }}</span>
                </span>
              </div>
            </ValidationProvider>
          </div>

          <div class="grid grid-cols-6 gap-6">
            <div class="col-span-6 sm:col-span-3">
              <label class="inline-flex items-center text-hint mb-1">
                <input
                  class="form-checkbox text-salesium-red focus:ring-salesium-red"
                  type="checkbox"
                  name="remember"
                  id="remember"
                  v-model="remember"
                />
                <span class="ml-2">Remember Me</span>
              </label>
            </div>

            <div class="col-span-6 sm:col-span-3 text-hint text-left sm:text-right">
              <div>
                <a href="/forgot-password">Forgot Password?</a>
              </div>
            </div>
          </div>

          <div class="text-center">
            <a href="/register" class="bronze-link">New to Salesium? Sign up here</a>
          </div>

          <div class="text-center">
            <button
              type="submit"
              class="primary-btn mt-6 px-12"
              :disabled="invalid"
            >
              Sign in
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  data() {
    return {
      username: "",
      password: "",
      remember: false,
      validationErrors: [],
      showPassword: false
    };
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      const response = await window.axios.post('/api/login', {
        username: this.username.toLowerCase(),
        password: this.password,
        remember: this.remember,
      }).catch(err => {
        console.error('ERROR:', err.response.data.message);
        if (err.response.status === 422 || err.response.status === 401) {
          this.validationErrors = ['Invalid credentials']
        }
      });

      if (response) {
        this.$toasted.global.toast_success('Successfully logged in');
        window.location.href = '/';
      }
    },
    clearValidationErrors() {
      if(this.validationErrors.length) {
        this.validationErrors = [];
      }
    },
      makeVisible() {
            this.showPassword = !this.showPassword;
      }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
};
</script>
